(function() {
  'use strict';

  const CONFIG = {
    giftTag: 'vetement',
    eligibleCollectionHandles: ['vetements'],
    requiredPaidBookProductId: '9159755464926',
    requiredPaidBookHandles: ['livre-go-for-it'],
    clothingKeywords: ['t-shirt', 'tshirt', 'tee-shirt', 'tee shirt'],
    checkoutRedirect: '/checkout',
    gifts: {
      bracelet: {
        productId: '9206907633886',
        variants: {
          noir: '48217291981022',
          rose: '48217292013790',
          jaune: '48217292046558'
        }
      },
      livre: {
        productId: '5981013541013',
        handle: 'la-force-de-lenergie-de-lamour-physique',
        variantId: null
      }
    },
    hoodiePromo: {
      marker: 'goforit_hoodie_collection',
      hoodieProductId: '8952326389982'
    }
  };

  let isProcessing = false;
  let popupShownForCartToken = '';

  function redirectAfterGifts() {
    window.location.href = CONFIG.checkoutRedirect;
  }

  function normalizeText(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  function getItemProductId(item) {
    return String(item.product_id || '');
  }

  function getItemVariantId(item) {
    return String(item.variant_id || item.id || '');
  }

  function isGiftItem(item) {
    return item.properties && item.properties._cadeau;
  }

  function isBraceletGiftItem(item) {
    return isGiftItem(item) && (
      getItemProductId(item) === CONFIG.gifts.bracelet.productId ||
      Object.keys(CONFIG.gifts.bracelet.variants).some(function(key) {
        return CONFIG.gifts.bracelet.variants[key] === getItemVariantId(item);
      })
    );
  }

  function isGiftBookGiftItem(item) {
    return isGiftItem(item) && (
      getItemProductId(item) === CONFIG.gifts.livre.productId ||
      item.handle === CONFIG.gifts.livre.handle
    );
  }

  function isHoodiePromoGiftItem(item) {
    return isGiftItem(item) &&
      item.properties &&
      item.properties._promo === CONFIG.hoodiePromo.marker;
  }

  function isHoodiePromoPaidItem(item) {
    return !isGiftItem(item) &&
      item.properties &&
      item.properties._promo === CONFIG.hoodiePromo.marker;
  }

  function cartHasHoodiePromoPaidPair(cart) {
    var hasHoodie = false;
    var hasStarter = false;

    cart.items.forEach(function(item) {
      if (!isHoodiePromoPaidItem(item)) return;

      if (getItemProductId(item) === CONFIG.hoodiePromo.hoodieProductId || item.properties._promo_role === 'hoodie') {
        hasHoodie = true;
      }

      if (item.properties._promo_role && item.properties._promo_role !== 'hoodie') {
        hasStarter = true;
      }
    });

    return hasHoodie && hasStarter;
  }

  function cartHasPaidItems(cart) {
    return cart.items.some(function(item) {
      return !isGiftItem(item) && item.quantity > 0;
    });
  }

  function cartHasBraceletGift(cart) {
    return cart.items.some(isBraceletGiftItem);
  }

  function cartHasGiftBookGift(cart) {
    return cart.items.some(isGiftBookGiftItem);
  }

  function isRequiredPaidBook(item) {
    return !isGiftItem(item) && (
      getItemProductId(item) === CONFIG.requiredPaidBookProductId ||
      CONFIG.requiredPaidBookHandles.indexOf(item.handle) !== -1
    );
  }

  function itemMatchesKeywords(item, keywords) {
    var text = normalizeText([
      item.handle,
      item.title,
      item.product_title,
      item.product_type,
      item.vendor
    ].join(' '));

    return keywords.some(function(keyword) {
      return text.indexOf(normalizeText(keyword)) !== -1;
    });
  }

  function getCartOfferToken(cart) {
    return cart.items
      .filter(function(item) { return !isGiftItem(item); })
      .map(function(item) { return item.key + ':' + item.quantity; })
      .sort()
      .join('|');
  }

  function getPopupOverlay() {
    var overlay = document.getElementById('bogo-popup-overlay');

    if (overlay && overlay.parentElement !== document.body) {
      document.body.appendChild(overlay);
    }

    return overlay;
  }

  function bindPopupEvents(overlay) {
    if (!overlay || overlay.dataset.bogoBound === 'true') return;

    var closeBtn = overlay.querySelector('#bogo-popup-close');
    var addBtn = overlay.querySelector('#bogo-add-gifts');

    if (closeBtn) closeBtn.addEventListener('click', closePopup);
    if (addBtn) addBtn.addEventListener('click', addGiftsToCart);

    overlay.addEventListener('click', function(event) {
      if (event.target === overlay) closePopup();
    });

    overlay.dataset.bogoBound = 'true';
  }

  function showPopup() {
    var overlay = getPopupOverlay();
    if (!overlay) return;

    bindPopupEvents(overlay);
    overlay.classList.add('bogo-popup-open');
    overlay.style.setProperty('display', 'flex', 'important');
    overlay.style.setProperty('visibility', 'visible', 'important');
    overlay.style.setProperty('opacity', '1', 'important');
    overlay.style.setProperty('position', 'fixed', 'important');
    overlay.style.setProperty('inset', '0', 'important');
    overlay.style.setProperty('z-index', '2147483647', 'important');
    document.body.style.overflow = 'hidden';
  }

  function closePopup() {
    var overlay = document.getElementById('bogo-popup-overlay');
    if (!overlay) return;

    overlay.classList.remove('bogo-popup-open');
    overlay.style.setProperty('display', 'none', 'important');
    document.body.style.overflow = '';
  }

  async function fetchCart() {
    return fetch('/cart.js').then(function(response) {
      return response.json();
    });
  }

  async function isProductTaggedEligible(productHandle) {
    try {
      var response = await fetch('/products/' + productHandle + '.js');
      if (!response.ok) return false;

      var product = await response.json();
      var tags = (product.tags || []).map(function(tag) {
        return normalizeText(tag);
      });

      return tags.indexOf(normalizeText(CONFIG.giftTag)) !== -1;
    } catch (error) {
      return false;
    }
  }

  async function isProductInEligibleCollection(productHandle) {
    for (var i = 0; i < CONFIG.eligibleCollectionHandles.length; i++) {
      try {
        var response = await fetch('/collections/' + CONFIG.eligibleCollectionHandles[i] + '/products/' + productHandle + '.js');
        if (response.ok) return true;
      } catch (error) {
        return false;
      }
    }

    return false;
  }

  async function isEligibleClothingItem(item) {
    if (isGiftItem(item) || isRequiredPaidBook(item) || item.quantity < 1) {
      return false;
    }

    if (itemMatchesKeywords(item, CONFIG.clothingKeywords)) {
      return true;
    }

    return false;
  }

  async function cartQualifiesForGifts(cart) {
    try {
      if (!cart) {
        cart = await fetchCart();
      }

      var hasEligibleClothing = false;
      var hasRequiredBook = false;

      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        if (isGiftItem(item)) continue;

        if (isRequiredPaidBook(item)) {
          hasRequiredBook = true;
        }

        if (await isEligibleClothingItem(item)) {
          hasEligibleClothing = true;
        }

        if (hasEligibleClothing && hasRequiredBook) {
          return true;
        }
      }
    } catch (error) {
      return false;
    }

    return false;
  }

  async function getGiftBookVariantId(source) {
    if (source && source.dataset && source.dataset.giftBookVariantId) {
      return source.dataset.giftBookVariantId;
    }

    if (CONFIG.gifts.livre.variantId) {
      return CONFIG.gifts.livre.variantId;
    }

    var overlay = document.getElementById('bogo-popup-overlay');
    var variantIdFromLiquid = overlay && overlay.dataset && overlay.dataset.giftBookVariantId;
    if (variantIdFromLiquid) {
      return variantIdFromLiquid;
    }

    throw new Error('Variant ID du livre cadeau introuvable.');
  }

  function getBraceletVariantId(source) {
    if (source) {
      var sourceSelect = source.querySelector('[data-goforit-bracelet-variant]');
      if (sourceSelect && sourceSelect.value) {
        return sourceSelect.value;
      }

      if (source.dataset && source.dataset.braceletVariantId) {
        return source.dataset.braceletVariantId;
      }
    }

    var selectedColor = document.querySelector('input[name="bracelet-color"]:checked');
    if (selectedColor && selectedColor.value) {
      return selectedColor.value;
    }

    return CONFIG.gifts.bracelet.variants.noir;
  }

  async function addCartItems(items) {
    var response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    });

    if (!response.ok) {
      throw new Error(await response.text());
    }

    return response.json();
  }

  async function changeCartItem(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    });
  }

  function buildBraceletGift(variantId) {
    return {
      id: variantId,
      quantity: 1,
      properties: {
        '_cadeau': 'Offert avec votre achat',
        '_cadeau_type': 'bracelet'
      }
    };
  }

  function buildGiftBook(variantId) {
    return {
      id: variantId,
      quantity: 1,
      properties: {
        '_cadeau': 'Offert avec votre achat',
        '_cadeau_type': 'livre'
      }
    };
  }

  function buildHoodiePromoPaid(variantId, quantity, role) {
    return {
      id: variantId,
      quantity: quantity,
      properties: {
        '_promo': CONFIG.hoodiePromo.marker,
        '_promo_role': role
      }
    };
  }

  function buildHoodiePromoGift(variantId, type) {
    return {
      id: variantId,
      quantity: 1,
      properties: {
        '_cadeau': 'Offert avec votre collection GO FOR IT',
        '_cadeau_type': type,
        '_promo': CONFIG.hoodiePromo.marker
      }
    };
  }

  function cartHasGiftVariant(cart, variantId) {
    return cart.items.some(function(item) {
      return isGiftItem(item) && getItemVariantId(item) === String(variantId);
    });
  }

  function queuedItemsHaveVariant(items, variantId) {
    return items.some(function(item) {
      return String(item.id) === String(variantId);
    });
  }

  function pushHoodiePromoGift(items, cart, variantId, type) {
    if (!variantId) return;
    if (cartHasGiftVariant(cart, variantId) || queuedItemsHaveVariant(items, variantId)) return;
    items.push(buildHoodiePromoGift(variantId, type));
  }

  async function syncGiftsToCart(cart, source) {
    if (isProcessing) return false;

    isProcessing = true;

    try {
      if (!cart) {
        cart = await fetchCart();
      }

      var changed = false;
      var qualifies = await cartQualifiesForGifts(cart);
      var hasPaidItems = cartHasPaidItems(cart);
      var hoodiePromoQualifies = cartHasHoodiePromoPaidPair(cart);
      var giftsToRemove = cart.items.filter(function(item) {
        if (!isGiftItem(item)) return false;
        if (isHoodiePromoGiftItem(item)) return !hoodiePromoQualifies;
        if (isGiftBookGiftItem(item)) return !qualifies;
        if (isBraceletGiftItem(item)) return !(qualifies || hoodiePromoQualifies);
        return !hasPaidItems;
      });

      for (var i = 0; i < giftsToRemove.length; i++) {
        await changeCartItem(giftsToRemove[i].key, 0);
        changed = true;
      }

      if (changed) {
        cart = await fetchCart();
        qualifies = await cartQualifiesForGifts(cart);
        hasPaidItems = cartHasPaidItems(cart);
        hoodiePromoQualifies = cartHasHoodiePromoPaidPair(cart);
      }

      var itemsToAdd = [];

      if ((qualifies || hoodiePromoQualifies) && !cartHasBraceletGift(cart)) {
        itemsToAdd.push(buildBraceletGift(getBraceletVariantId(source)));
      }

      if (qualifies && !cartHasGiftBookGift(cart)) {
        itemsToAdd.push(buildGiftBook(await getGiftBookVariantId(source)));
      }

      if (itemsToAdd.length > 0) {
        await addCartItems(itemsToAdd);
        changed = true;
      }

      return changed;
    } finally {
      isProcessing = false;
    }
  }

  async function addGiftsToCart() {
    if (isProcessing) return;

    var overlay = document.getElementById('bogo-popup-overlay');
    var selectedColor = document.querySelector('input[name="bracelet-color"]:checked');
    if (!selectedColor) {
      alert('Veuillez choisir une couleur pour le bracelet');
      return;
    }

    try {
      var cart = await fetchCart();

      if (!(await cartQualifiesForGifts(cart))) {
        alert('Veuillez ajouter le livre GO FOR IT et un T-shirt admissible pour obtenir les cadeaux.');
        return;
      }

      if (await syncGiftsToCart(cart, overlay)) {
        closePopup();
        redirectAfterGifts();
        return;
      }

      closePopup();
      redirectAfterGifts();
    } catch (error) {
      alert('Une erreur est survenue. Veuillez réessayer.');
    }
  }

  async function monitorCart() {
    if (isProcessing) return;

    try {
      var changed = await syncGiftsToCart();
      if (changed && window.location.pathname === '/cart') {
        window.location.reload();
      }
    } catch (error) {}
  }

  async function checkCart() {
    if (isProcessing) return;

    try {
      var cart = await fetchCart();
      var changed = await syncGiftsToCart(cart);
      var cartToken = getCartOfferToken(cart);

      if (!changed && (await cartQualifiesForGifts(cart)) && !cartHasGiftBookGift(cart) && cartToken !== popupShownForCartToken) {
        showPopup();
        popupShownForCartToken = cartToken;
      }
    } catch (error) {}
  }

  function decodeHtmlEntities(value) {
    var textarea = document.createElement('textarea');
    textarea.innerHTML = value || '';
    return textarea.value;
  }

  function formatOfferMoney(cents) {
    if (window.theme && window.theme.Currency && typeof window.theme.Currency.formatMoney === 'function') {
      return window.theme.Currency.formatMoney(cents, window.theme.settings && window.theme.settings.moneyFormat);
    }

    return '$' + (cents / 100).toFixed(2);
  }

  function getSelectedOption(select) {
    if (!select || select.selectedIndex < 0) return null;
    return select.options[select.selectedIndex] || null;
  }

  function getAvailableTshirtOptions(select) {
    var options = [];
    if (!select) return options;

    Array.prototype.forEach.call(select.options, function(option) {
      if (!option.disabled) {
        options.push(option);
      }
    });

    return options;
  }

  function getUniqueOptionValues(options, attribute) {
    var values = [];

    options.forEach(function(option) {
      var value = option.dataset[attribute] || '';
      if (value && values.indexOf(value) === -1) {
        values.push(value);
      }
    });

    return values;
  }

  function populateChoiceSelect(select, values, selectedValue) {
    if (!select) return;

    select.innerHTML = '';

    values.forEach(function(value) {
      var option = document.createElement('option');
      option.value = value;
      option.textContent = value;
      if (value === selectedValue) {
        option.selected = true;
      }
      select.appendChild(option);
    });
  }

  function findTshirtOption(options, color, size) {
    for (var i = 0; i < options.length; i++) {
      if ((options[i].dataset.color || '') === color && (options[i].dataset.size || '') === size) {
        return options[i];
      }
    }

    return null;
  }

  function getActiveTshirtModel(offer) {
    var checkedModel = offer.querySelector('[data-goforit-tshirt-model]:checked');
    if (checkedModel && checkedModel.value) return checkedModel.value;

    var firstModel = offer.querySelector('[data-goforit-tshirt-model]');
    return firstModel && firstModel.value ? firstModel.value : 'homme';
  }

  function getActiveTshirtSelect(offer) {
    var productSelect = offer.querySelector('[data-goforit-tshirt-product]');
    if (productSelect && productSelect.value) {
      var productSources = offer.querySelectorAll('[data-goforit-tshirt-variant]');
      for (var productIndex = 0; productIndex < productSources.length; productIndex++) {
        if (productSources[productIndex].dataset.goforitProduct === productSelect.value) {
          return productSources[productIndex];
        }
      }
    }

    var activeModel = getActiveTshirtModel(offer);
    var selects = offer.querySelectorAll('[data-goforit-tshirt-variant]');

    for (var i = 0; i < selects.length; i++) {
      if (selects[i].dataset.goforitModel === activeModel) {
        return selects[i];
      }
    }

    return selects[0] || null;
  }

  function updateTshirtChoices(offer, modelChanged) {
    var sourceSelect = getActiveTshirtSelect(offer);
    var genericChoice = offer.querySelector('[data-goforit-tshirt-choice]');
    var colorSelect = offer.querySelector('[data-goforit-tshirt-color]');
    var sizeSelect = offer.querySelector('[data-goforit-tshirt-size]');
    var options = getAvailableTshirtOptions(sourceSelect);

    if (sourceSelect && genericChoice && options.length > 0) {
      var preferredVariantId = modelChanged ? '' : genericChoice.value;
      genericChoice.innerHTML = '';

      options.forEach(function(sourceOption) {
        var option = document.createElement('option');
        option.value = sourceOption.value;
        option.textContent = sourceOption.textContent;
        option.dataset.price = sourceOption.dataset.price || '';
        option.dataset.image = sourceOption.dataset.image || '';
        genericChoice.appendChild(option);
      });

      var selectedOption = options.find(function(option) {
        return option.value === preferredVariantId;
      }) || getSelectedOption(sourceSelect) || options[0];

      genericChoice.value = selectedOption.value;
      sourceSelect.value = selectedOption.value;
      return selectedOption;
    }

    if (!sourceSelect || !colorSelect || !sizeSelect || options.length === 0) {
      return getSelectedOption(sourceSelect);
    }

    var selectedSourceOption = getSelectedOption(sourceSelect);
    if (!selectedSourceOption || selectedSourceOption.disabled) {
      selectedSourceOption = options[0];
    }

    var colorValues = getUniqueOptionValues(options, 'color');
    var preferredColor = modelChanged ? selectedSourceOption.dataset.color : colorSelect.value;
    var selectedColor = colorValues.indexOf(preferredColor) !== -1 ? preferredColor : selectedSourceOption.dataset.color;

    if (colorValues.indexOf(selectedColor) === -1) {
      selectedColor = colorValues[0] || '';
    }

    populateChoiceSelect(colorSelect, colorValues, selectedColor);

    var optionsForColor = options.filter(function(option) {
      return (option.dataset.color || '') === selectedColor;
    });

    if (optionsForColor.length === 0) {
      optionsForColor = options;
    }

    var sizeValues = getUniqueOptionValues(optionsForColor, 'size');
    var preferredSize = modelChanged ? selectedSourceOption.dataset.size : sizeSelect.value;
    var selectedSize = sizeValues.indexOf(preferredSize) !== -1 ? preferredSize : selectedSourceOption.dataset.size;

    if (sizeValues.indexOf(selectedSize) === -1) {
      selectedSize = sizeValues[0] || '';
    }

    populateChoiceSelect(sizeSelect, sizeValues, selectedSize);

    var selectedVariant = findTshirtOption(options, selectedColor, selectedSize) || optionsForColor[0] || options[0];

    if (selectedVariant) {
      sourceSelect.value = selectedVariant.value;
      selectedVariant.selected = true;
    }

    return selectedVariant;
  }

  function getCurrentTshirtOption(offer) {
    var sourceSelect = getActiveTshirtSelect(offer);
    var genericChoice = offer.querySelector('[data-goforit-tshirt-choice]');
    var colorSelect = offer.querySelector('[data-goforit-tshirt-color]');
    var sizeSelect = offer.querySelector('[data-goforit-tshirt-size]');
    var options = getAvailableTshirtOptions(sourceSelect);
    var selectedVariant = null;

    if (genericChoice && sourceSelect) {
      selectedVariant = Array.from(sourceSelect.options).find(function(option) {
        return !option.disabled && option.value === genericChoice.value;
      });
    }

    if (colorSelect && sizeSelect) {
      selectedVariant = findTshirtOption(options, colorSelect.value, sizeSelect.value);
    }

    return selectedVariant || getSelectedOption(sourceSelect) || options[0] || null;
  }

  function updateTshirtModel(offer) {
    var productSelect = offer.querySelector('[data-goforit-tshirt-product]');
    var activeModel = productSelect && productSelect.value ? productSelect.value : getActiveTshirtModel(offer);
    var modelChanged = offer.dataset.activeTshirtModel !== activeModel;
    offer.dataset.activeTshirtModel = activeModel;

    var select = getActiveTshirtSelect(offer);
    var selectedOption = updateTshirtChoices(offer, modelChanged);
    var title = select && select.dataset.productTitle;
    var image = selectedOption && selectedOption.dataset.image;
    var productImage = select && select.dataset.productImage;
    var price = selectedOption && parseInt(selectedOption.dataset.price || '0', 10);

    var titleEl = offer.querySelector('[data-goforit-tshirt-title]');
    if (titleEl && title) {
      titleEl.textContent = title;
    }

    var priceEl = offer.querySelector('[data-goforit-tshirt-price]');
    if (priceEl && price) {
      priceEl.textContent = formatOfferMoney(price);
    }

    var imageEl = offer.querySelector('[data-goforit-tshirt-image]');
    if (imageEl && (image || productImage)) {
      imageEl.src = image || productImage;
      if (title) imageEl.alt = title;
    }
  }

  function updateBraceletPresentation(offer) {
    var select = offer.querySelector('[data-goforit-bracelet-variant]');
    var selectedOption = getSelectedOption(select);
    var image = selectedOption && selectedOption.dataset.image;
    var imageEl = offer.querySelector('[data-goforit-bracelet-image]');

    if (imageEl && image) {
      imageEl.src = image;
    }
  }

  function updateOfferTotal(form, offer) {
    var includeTshirt = offer.querySelector('[data-goforit-include-tshirt]');
    var totalEl = offer.querySelector('[data-goforit-total]');
    var offerMode = offer.dataset.goforitOfferMode || 'book';
    var currentPrice = parseInt(offer.dataset.currentPrice || offer.dataset.bookPrice || '0', 10);
    var bookPrice = parseInt(offer.dataset.bookPrice || '0', 10);
    var giftBookPrice = parseInt(offer.dataset.giftBookPrice || '0', 10);
    var tshirtPrice = 0;
    var paidItemsPrice = currentPrice;

    if (includeTshirt && includeTshirt.checked) {
      if (offerMode === 'tshirt') {
        paidItemsPrice += bookPrice;
      } else {
        var tshirtOption = getCurrentTshirtOption(offer);
        tshirtPrice = parseInt((tshirtOption && tshirtOption.dataset.price) || '0', 10);
        paidItemsPrice += tshirtPrice;
      }
    }

    if (totalEl) {
      totalEl.textContent = formatOfferMoney(paidItemsPrice);
    }

    var regularValueEl = offer.querySelector('[data-goforit-regular-value]');
    if (regularValueEl) {
      regularValueEl.textContent = formatOfferMoney(paidItemsPrice + (includeTshirt && includeTshirt.checked ? giftBookPrice : 0));
    }

    var savingsEl = offer.querySelector('[data-goforit-savings]');
    if (savingsEl) {
      savingsEl.textContent = formatOfferMoney(includeTshirt && includeTshirt.checked ? giftBookPrice : 0);
    }

    offer.classList.toggle('goforit-offer--book-only', includeTshirt && !includeTshirt.checked);

    var controls = offer.querySelector('[data-goforit-tshirt-controls]');
    if (controls && includeTshirt) {
      controls.hidden = !includeTshirt.checked;
    }
  }

  function getHoodieStarter(offer) {
    if (offer.dataset.hoodieOfferMode === 'starter' && offer.dataset.hoodieStarterRole) {
      return offer.dataset.hoodieStarterRole;
    }

    var checkedStarter = offer.querySelector('[data-hoodie-starter]:checked');
    return checkedStarter && checkedStarter.value ? checkedStarter.value : 'book';
  }

  function getHoodieTshirtModel(offer) {
    var productSelect = offer.querySelector('[data-hoodie-tshirt-product]');
    if (productSelect && productSelect.value) {
      return productSelect.value;
    }

    var checkedModel = offer.querySelector('[data-hoodie-tshirt-model]:checked');
    return checkedModel && checkedModel.value ? checkedModel.value : 'homme';
  }

  function getHoodieActiveTshirtSource(offer) {
    var activeModel = getHoodieTshirtModel(offer);
    var selects = offer.querySelectorAll('[data-hoodie-tshirt-variant]');

    for (var i = 0; i < selects.length; i++) {
      if (selects[i].dataset.hoodieProduct === activeModel || selects[i].dataset.hoodieModel === activeModel) {
        return selects[i];
      }
    }

    return selects[0] || null;
  }

  function updateHoodieTshirtChoices(offer, modelChanged) {
    var sourceSelect = getHoodieActiveTshirtSource(offer);
    var colorSelect = offer.querySelector('[data-hoodie-tshirt-color]');
    var sizeSelect = offer.querySelector('[data-hoodie-tshirt-size]');
    var options = getAvailableTshirtOptions(sourceSelect);

    if (!sourceSelect || !colorSelect || !sizeSelect || options.length === 0) {
      return getSelectedOption(sourceSelect);
    }

    var selectedSourceOption = getSelectedOption(sourceSelect);
    if (!selectedSourceOption || selectedSourceOption.disabled) {
      selectedSourceOption = options[0];
    }

    var colorValues = getUniqueOptionValues(options, 'color');
    var preferredColor = modelChanged ? selectedSourceOption.dataset.color : colorSelect.value;
    var selectedColor = colorValues.indexOf(preferredColor) !== -1 ? preferredColor : selectedSourceOption.dataset.color;

    if (colorValues.indexOf(selectedColor) === -1) {
      selectedColor = colorValues[0] || '';
    }

    populateChoiceSelect(colorSelect, colorValues, selectedColor);

    var optionsForColor = options.filter(function(option) {
      return (option.dataset.color || '') === selectedColor;
    });

    if (optionsForColor.length === 0) {
      optionsForColor = options;
    }

    var sizeValues = getUniqueOptionValues(optionsForColor, 'size');
    var preferredSize = modelChanged ? selectedSourceOption.dataset.size : sizeSelect.value;
    var selectedSize = sizeValues.indexOf(preferredSize) !== -1 ? preferredSize : selectedSourceOption.dataset.size;

    if (sizeValues.indexOf(selectedSize) === -1) {
      selectedSize = sizeValues[0] || '';
    }

    populateChoiceSelect(sizeSelect, sizeValues, selectedSize);

    var selectedVariant = findTshirtOption(options, selectedColor, selectedSize) || optionsForColor[0] || options[0];

    if (selectedVariant) {
      sourceSelect.value = selectedVariant.value;
      selectedVariant.selected = true;
    }

    return selectedVariant;
  }

  function getHoodieCurrentTshirtOption(offer) {
    var sourceSelect = getHoodieActiveTshirtSource(offer);
    var colorSelect = offer.querySelector('[data-hoodie-tshirt-color]');
    var sizeSelect = offer.querySelector('[data-hoodie-tshirt-size]');
    var options = getAvailableTshirtOptions(sourceSelect);
    var selectedVariant = null;

    if (colorSelect && sizeSelect) {
      selectedVariant = findTshirtOption(options, colorSelect.value, sizeSelect.value);
    }

    return selectedVariant || getSelectedOption(sourceSelect) || options[0] || null;
  }

  function getHoodieProductOption(offer) {
    var sourceSelect = offer.querySelector('[data-hoodie-product-variant]');
    var colorSelect = offer.querySelector('[data-hoodie-product-color]');
    var sizeSelect = offer.querySelector('[data-hoodie-product-size]');
    var options = getAvailableTshirtOptions(sourceSelect);
    var selectedVariant = null;

    if (colorSelect && sizeSelect) {
      selectedVariant = findTshirtOption(options, colorSelect.value, sizeSelect.value);
    }

    return selectedVariant || getSelectedOption(sourceSelect) || options[0] || null;
  }

  function updateHoodieProductChoices(offer) {
    var sourceSelect = offer.querySelector('[data-hoodie-product-variant]');
    var colorSelect = offer.querySelector('[data-hoodie-product-color]');
    var sizeSelect = offer.querySelector('[data-hoodie-product-size]');
    var options = getAvailableTshirtOptions(sourceSelect);

    if (!sourceSelect || !colorSelect || !sizeSelect || options.length === 0) {
      return getSelectedOption(sourceSelect);
    }

    var selectedSourceOption = getSelectedOption(sourceSelect);
    if (!selectedSourceOption || selectedSourceOption.disabled) selectedSourceOption = options[0];

    var colorValues = getUniqueOptionValues(options, 'color');
    var selectedColor = colorValues.indexOf(colorSelect.value) !== -1 ? colorSelect.value : selectedSourceOption.dataset.color;
    if (colorValues.indexOf(selectedColor) === -1) selectedColor = colorValues[0] || '';
    populateChoiceSelect(colorSelect, colorValues, selectedColor);

    var optionsForColor = options.filter(function(option) {
      return (option.dataset.color || '') === selectedColor;
    });
    if (optionsForColor.length === 0) optionsForColor = options;

    var sizeValues = getUniqueOptionValues(optionsForColor, 'size');
    var selectedSize = sizeValues.indexOf(sizeSelect.value) !== -1 ? sizeSelect.value : selectedSourceOption.dataset.size;
    if (sizeValues.indexOf(selectedSize) === -1) selectedSize = sizeValues[0] || '';
    populateChoiceSelect(sizeSelect, sizeValues, selectedSize);

    var selectedVariant = findTshirtOption(options, selectedColor, selectedSize) || optionsForColor[0] || options[0];
    sourceSelect.value = selectedVariant.value;
    selectedVariant.selected = true;
    offer.dataset.hoodiePrice = selectedVariant.dataset.price || offer.dataset.hoodiePrice;
    updateTextGroup(offer, '[data-hoodie-current-price]', formatOfferMoney(parseInt(selectedVariant.dataset.price || '0', 10)));
    updateImageGroup(offer, '[data-hoodie-current-image]', selectedVariant.dataset.image, offer.querySelector('[data-hoodie-current-title]') && offer.querySelector('[data-hoodie-current-title]').textContent);
    return selectedVariant;
  }

  function getHoodieActiveCapSource(offer) {
    var productSelect = offer.querySelector('[data-hoodie-cap-product]');
    var activeProduct = productSelect && productSelect.value;
    var selects = offer.querySelectorAll('[data-hoodie-cap-variant]');

    for (var i = 0; i < selects.length; i++) {
      if (!activeProduct || selects[i].dataset.hoodieProduct === activeProduct) return selects[i];
    }

    return selects[0] || null;
  }

  function updateHoodieCapChoices(offer) {
    var sourceSelect = getHoodieActiveCapSource(offer);
    var colorSelect = offer.querySelector('[data-hoodie-cap-color]');
    var options = getAvailableTshirtOptions(sourceSelect);

    if (!sourceSelect || !colorSelect || options.length === 0) {
      return getSelectedOption(sourceSelect);
    }

    var selectedSourceOption = getSelectedOption(sourceSelect);
    if (!selectedSourceOption || selectedSourceOption.disabled) {
      selectedSourceOption = options[0];
    }

    var colorValues = getUniqueOptionValues(options, 'color');
    var selectedColor = colorValues.indexOf(colorSelect.value) !== -1 ? colorSelect.value : selectedSourceOption.dataset.color;

    if (colorValues.indexOf(selectedColor) === -1) {
      selectedColor = colorValues[0] || '';
    }

    populateChoiceSelect(colorSelect, colorValues, selectedColor);

    var selectedVariant = null;
    for (var i = 0; i < options.length; i++) {
      if ((options[i].dataset.color || '') === selectedColor) {
        selectedVariant = options[i];
        break;
      }
    }

    selectedVariant = selectedVariant || options[0];
    sourceSelect.value = selectedVariant.value;
    selectedVariant.selected = true;

    return selectedVariant;
  }

  function getHoodieCurrentCapOption(offer) {
    var sourceSelect = getHoodieActiveCapSource(offer);
    var colorSelect = offer.querySelector('[data-hoodie-cap-color]');
    var options = getAvailableTshirtOptions(sourceSelect);

    if (colorSelect) {
      for (var i = 0; i < options.length; i++) {
        if ((options[i].dataset.color || '') === colorSelect.value) {
          return options[i];
        }
      }
    }

    return getSelectedOption(sourceSelect) || options[0] || null;
  }

  function getHoodieBraceletVariantId(offer) {
    var select = offer.querySelector('[data-hoodie-bracelet-variant]');
    return select && select.value ? select.value : getBraceletVariantId(offer);
  }

  function updateHoodieBraceletPresentation(offer) {
    var select = offer.querySelector('[data-hoodie-bracelet-variant]');
    var selectedOption = getSelectedOption(select);
    var image = selectedOption && selectedOption.dataset.image;
    if (image) {
      offer.querySelectorAll('[data-hoodie-bracelet-image]').forEach(function(imageEl) {
        imageEl.src = image;
      });
    }
  }

  function isStarterHoodieOffer(offer) {
    return offer.dataset.hoodieOfferMode === 'starter';
  }

  function getStarterHoodieOption(offer) {
    var select = offer.querySelector('[data-starter-hoodie-variant]');
    var selectedOption = getSelectedOption(select);
    if (selectedOption && !selectedOption.disabled) {
      return selectedOption;
    }

    var options = getAvailableTshirtOptions(select);
    if (select && options.length > 0) {
      select.value = options[0].value;
      options[0].selected = true;
      return options[0];
    }

    return selectedOption;
  }

  function getStarterHoodiePrice(offer) {
    var hoodieOption = getStarterHoodieOption(offer);
    return parseInt((hoodieOption && hoodieOption.dataset.price) || '0', 10);
  }

  function getStarterProductSource(offer) {
    return offer.querySelector('[data-starter-product-source-variant]');
  }

  function getFormVariantId(offer) {
    var form = offer.closest('form');
    var variantInput = form && form.querySelector('[name="id"]');
    return variantInput && variantInput.value ? variantInput.value : '';
  }

  function syncStarterProductSourceFromForm(offer, sourceSelect) {
    var variantId = getFormVariantId(offer);
    if (!sourceSelect || !variantId) return;

    Array.prototype.forEach.call(sourceSelect.options, function(option) {
      if (option.value === variantId) {
        sourceSelect.value = variantId;
        option.selected = true;
      }
    });
  }

  function getStarterProductOption(offer) {
    var sourceSelect = getStarterProductSource(offer);
    var options = getAvailableTshirtOptions(sourceSelect);
    var controls = offer.querySelectorAll('[data-starter-product-option]');

    if (!sourceSelect || options.length === 0) {
      return getSelectedOption(sourceSelect);
    }

    syncStarterProductSourceFromForm(offer, sourceSelect);
    var selectedOption = getSelectedOption(sourceSelect);

    if (controls.length > 0) {
      for (var i = 0; i < options.length; i++) {
        var option = options[i];
        var matches = true;

        controls.forEach(function(control) {
          var position = control.dataset.optionPosition;
          if (position && (option.dataset['option' + position] || '') !== control.value) {
            matches = false;
          }
        });

        if (matches) {
          sourceSelect.value = option.value;
          option.selected = true;
          return option;
        }
      }
    }

    if (selectedOption && !selectedOption.disabled) {
      return selectedOption;
    }

    sourceSelect.value = options[0].value;
    options[0].selected = true;
    return options[0];
  }

  function getStarterProductVariantId(offer) {
    var starterOption = getStarterProductOption(offer);
    return starterOption && !starterOption.disabled ? starterOption.value : '';
  }

  function getStarterProductPrice(offer) {
    var starterOption = getStarterProductOption(offer);
    return parseInt((starterOption && starterOption.dataset.price) || offer.dataset.starterPrice || '0', 10);
  }

  function syncStarterProductFormVariant(offer, starterOption) {
    return starterOption;
  }

  function updateStarterProductCard(offer) {
    var sourceSelect = getStarterProductSource(offer);
    var starterOption = getStarterProductOption(offer);
    var title = sourceSelect && sourceSelect.dataset.productTitle;
    var image = (starterOption && starterOption.dataset.image) || (sourceSelect && sourceSelect.dataset.productImage);
    var price = getStarterProductPrice(offer);

    updateTextGroup(offer, '[data-starter-product-title]', title);
    updateImageGroup(offer, '[data-starter-product-image]', image, title);

    offer.querySelectorAll('[data-starter-product-price]').forEach(function(priceEl) {
      priceEl.textContent = formatOfferMoney(price);
    });

    syncStarterProductFormVariant(offer, starterOption);
  }

  function updateStarterHoodieCard(offer) {
    var select = offer.querySelector('[data-starter-hoodie-variant]');
    var hoodieOption = getStarterHoodieOption(offer);
    var title = select && select.dataset.productTitle;
    var image = (hoodieOption && hoodieOption.dataset.image) || (select && select.dataset.productImage);
    var price = getStarterHoodiePrice(offer);
    offer.querySelectorAll('[data-starter-hoodie-title]').forEach(function(titleEl) {
      if (title) titleEl.textContent = title;
    });

    offer.querySelectorAll('[data-starter-hoodie-image]').forEach(function(imageEl) {
      if (image) {
        imageEl.src = image;
        if (title) imageEl.alt = title;
      }
    });

    offer.querySelectorAll('[data-starter-hoodie-price]').forEach(function(priceEl) {
      priceEl.textContent = formatOfferMoney(price);
    });
  }

  function updateStarterValueNote(offer) {
    var noteEl = offer.querySelector('[data-hoodie-value-note]');
    var template = offer.dataset.hoodieValueNoteTemplate;
    if (!noteEl || !template) return;

    var starterSource = getStarterProductSource(offer);
    var hoodieSelect = offer.querySelector('[data-starter-hoodie-variant]');
    var starterTitle =
      (starterSource && starterSource.dataset.productTitle) ||
      (offer.querySelector('[data-starter-product-title]') || {}).textContent ||
      '';
    var hoodieTitle =
      (hoodieSelect && hoodieSelect.dataset.productTitle) ||
      (offer.querySelector('[data-starter-hoodie-title]') || {}).textContent ||
      '';

    noteEl.textContent = template
      .replace(/\{produit_base\}/g, starterTitle)
      .replace(/\{produit_complementaire\}/g, hoodieTitle);
  }

  function isTruthyData(value) {
    return value === true || value === 'true';
  }

  function getDynamicGiftCards(offer) {
    return Array.prototype.slice.call(offer.querySelectorAll('[data-hoodie-dynamic-gift]'));
  }

  function getVisibleDynamicGiftCards(offer) {
    return getDynamicGiftCards(offer).filter(function(card) {
      return !card.hidden;
    });
  }

  function getDynamicGiftChoiceQuantity(offer) {
    var quantity = parseInt(offer.dataset.hoodieGiftChoiceQuantity || '1', 10);
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function getDynamicGiftVariantId(card) {
    var variantControl = card.querySelector('[data-hoodie-dynamic-gift-variant]');
    return variantControl && variantControl.value ? variantControl.value : '';
  }

  function updateDynamicGiftPresentation(card) {
    var variantControl = card.querySelector('[data-hoodie-dynamic-gift-variant]');
    var imageEl = card.querySelector('[data-hoodie-dynamic-gift-image]');
    var selectedOption = variantControl && variantControl.options ? getSelectedOption(variantControl) : null;

    if (imageEl && selectedOption && selectedOption.dataset.image) {
      imageEl.src = selectedOption.dataset.image;
    }

    var choiceInput = card.querySelector('[data-hoodie-dynamic-gift-input]');
    if (choiceInput) {
      choiceInput.value = getDynamicGiftVariantId(card);
    }
  }

  function updateDynamicGiftChoices(offer) {
    var cards = getDynamicGiftCards(offer);
    if (cards.length === 0) return;

    var mode = offer.dataset.hoodieGiftSelectionMode || 'auto_all';
    var choiceQuantity = getDynamicGiftChoiceQuantity(offer);
    var excludePurchased = isTruthyData(offer.dataset.hoodieExcludePurchasedProducts);
    var excludeSameType = isTruthyData(offer.dataset.hoodieExcludeSameProductType);
    var starterHandle = offer.dataset.hoodieStarterProductHandle || '';
    var complementaryHandle = offer.dataset.hoodieComplementaryProductHandle || '';
    var starterType = normalizeText(offer.dataset.hoodieStarterProductType || '');
    var complementaryType = normalizeText(offer.dataset.hoodieComplementaryProductType || '');

    cards.forEach(function(card) {
      updateDynamicGiftPresentation(card);

      var productHandle = card.dataset.productHandle || '';
      var productType = normalizeText(card.dataset.productType || '');
      var shouldHide =
        (excludePurchased && (productHandle === starterHandle || productHandle === complementaryHandle)) ||
        (excludeSameType && productType && (productType === starterType || productType === complementaryType));
      var input = card.querySelector('[data-hoodie-dynamic-gift-input]');

      card.dataset.dynamicGiftExcluded = shouldHide ? 'true' : 'false';
      card.hidden = shouldHide;
      card.classList.remove('is-selected', 'is-choice-hidden');
      if (shouldHide && input) {
        input.checked = false;
      }
    });

    var visibleCards = getVisibleDynamicGiftCards(offer);
    var selectedInputs = visibleCards
      .map(function(card) { return card.querySelector('[data-hoodie-dynamic-gift-input]'); })
      .filter(function(input) { return input && input.checked; });
    var selectionFull = mode === 'customer_choice' && selectedInputs.length >= Math.min(choiceQuantity, visibleCards.length);
    var selectedCard = selectedInputs.length > 0 ? selectedInputs[0].closest('[data-hoodie-dynamic-gift]') : null;
    var lockSingleChoice = mode === 'customer_choice' && choiceQuantity === 1 && selectedCard;

    visibleCards.forEach(function(card) {
      var input = card.querySelector('[data-hoodie-dynamic-gift-input]');
      var selectButton = card.querySelector('[data-hoodie-dynamic-gift-select]');
      var choiceLabel = card.querySelector('[data-hoodie-dynamic-gift-choice-label]');
      var isSelected = input && input.checked;

      if (lockSingleChoice && card !== selectedCard) {
        card.hidden = true;
        card.classList.add('is-choice-hidden');
      }

      if (input) {
        input.disabled = selectionFull && !input.checked && !lockSingleChoice;
      }

      card.classList.toggle('is-selected', !!isSelected);

      if (selectButton) {
        selectButton.textContent = isSelected ? 'Selectionne' : 'Choisir';
        selectButton.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      }

      if (choiceLabel) {
        choiceLabel.textContent = isSelected ? 'Selectionne' : 'Choisir ce cadeau';
      }
    });

    var note = offer.querySelector('[data-hoodie-dynamic-gift-note]');
    if (note && mode === 'customer_choice') {
      var requiredQuantity = Math.min(choiceQuantity, visibleCards.length);
      note.textContent = selectedInputs.length >= requiredQuantity
        ? 'Votre cadeau est selectionne.'
        : 'Choisissez ' + requiredQuantity + ' cadeau(x) gratuit(s).';
    }

    var resetButton = offer.querySelector('[data-hoodie-dynamic-gift-reset]');
    if (resetButton) {
      resetButton.hidden = !lockSingleChoice;
    }
  }

  function getDynamicGiftVariantIdsForCart(offer) {
    var cards = getVisibleDynamicGiftCards(offer);
    if (getDynamicGiftCards(offer).length === 0 || cards.length === 0) {
      return { ids: [], error: '' };
    }

    var mode = offer.dataset.hoodieGiftSelectionMode || 'auto_all';
    var choiceQuantity = getDynamicGiftChoiceQuantity(offer);

    if (mode === 'customer_choice') {
      var selectedCards = cards.filter(function(card) {
        var input = card.querySelector('[data-hoodie-dynamic-gift-input]');
        return input && input.checked;
      });
      var requiredQuantity = Math.min(choiceQuantity, cards.length);

      if (selectedCards.length < requiredQuantity) {
        return {
          ids: [],
          error: 'Veuillez choisir ' + requiredQuantity + ' cadeau(x) gratuit(s).'
        };
      }

      cards = selectedCards.slice(0, requiredQuantity);
    }

    return {
      ids: cards.map(getDynamicGiftVariantId).filter(Boolean),
      error: ''
    };
  }

  function setDynamicGiftSelected(offer, card, selected) {
    var input = card && card.querySelector('[data-hoodie-dynamic-gift-input]');
    if (!input || input.disabled) return;

    var isSelected = typeof selected === 'boolean' ? selected : !input.checked;
    if (isSelected && getDynamicGiftChoiceQuantity(offer) === 1) {
      offer.querySelectorAll('[data-hoodie-dynamic-gift-input]').forEach(function(otherInput) {
        if (otherInput !== input) {
          otherInput.checked = false;
        }
      });
    }

    input.checked = isSelected;
    updateHoodieOffer(offer);
  }

  function resetDynamicGiftSelection(offer) {
    offer.querySelectorAll('[data-hoodie-dynamic-gift-input]').forEach(function(input) {
      input.checked = false;
      input.disabled = false;
    });
    updateHoodieOffer(offer);
  }

  function closeDynamicGiftModal(offer) {
    var modal = offer.querySelector('[data-hoodie-gift-modal]');
    if (!modal) return;

    modal.hidden = true;
    document.documentElement.classList.remove('goforit-gift-modal-open');
  }

  function openDynamicGiftModal(offer, card) {
    var modal = offer.querySelector('[data-hoodie-gift-modal]');
    if (!modal || !card) return;

    var image = modal.querySelector('[data-hoodie-gift-modal-image]');
    var title = modal.querySelector('[data-hoodie-gift-modal-title]');
    var description = modal.querySelector('[data-hoodie-gift-modal-description]');
    var link = modal.querySelector('[data-hoodie-gift-modal-link]');
    var closeButton = modal.querySelector('[data-hoodie-gift-modal-close]');

    if (image) {
      if (card.dataset.productImage) {
        image.src = card.dataset.productImage;
        image.alt = card.dataset.productTitle || '';
        image.hidden = false;
      } else {
        image.hidden = true;
      }
    }

    if (title) {
      title.textContent = card.dataset.productTitle || '';
    }

    if (description) {
      description.textContent = card.dataset.productDescription || 'Details du produit disponibles sur la fiche produit.';
    }

    if (link) {
      link.href = card.dataset.productUrl || '#';
    }

    modal.hidden = false;
    document.documentElement.classList.add('goforit-gift-modal-open');

    if (closeButton) {
      closeButton.focus();
    }
  }

  function updateImageGroup(offer, selector, image, title) {
    if (!image) return;

    offer.querySelectorAll(selector).forEach(function(imageEl) {
      imageEl.src = image;
      if (title) {
        imageEl.alt = title;
      }
    });
  }

  function updateTextGroup(offer, selector, text) {
    if (!text) return;

    offer.querySelectorAll(selector).forEach(function(textEl) {
      textEl.textContent = text;
    });
  }

  function getHoodieStarterPrice(offer) {
    var starter = getHoodieStarter(offer);

    if (starter === 'tshirt') {
      var tshirtOption = getHoodieCurrentTshirtOption(offer);
      return parseInt((tshirtOption && tshirtOption.dataset.price) || '0', 10);
    }

    if (starter === 'cap') {
      var capOption = getHoodieCurrentCapOption(offer);
      return parseInt((capOption && capOption.dataset.price) || '0', 10);
    }

    if (starter === 'love_book') {
      return parseInt(offer.dataset.giftBookPrice || '0', 10);
    }

    return parseInt(offer.dataset.paidBookPrice || '0', 10);
  }

  function updateHoodiePaidCard(offer) {
    var starter = getHoodieStarter(offer);
    var titleEl = offer.querySelector('[data-hoodie-paid-title]');
    var priceEl = offer.querySelector('[data-hoodie-paid-price]');
    var imageEl = offer.querySelector('[data-hoodie-paid-image]');
    var title = '';
    var image = '';
    var price = getHoodieStarterPrice(offer);

    if (starter === 'tshirt') {
      var tshirtSource = getHoodieActiveTshirtSource(offer);
      var tshirtOption = getHoodieCurrentTshirtOption(offer);
      title = tshirtSource && tshirtSource.dataset.productTitle;
      image = (tshirtOption && tshirtOption.dataset.image) || (tshirtSource && tshirtSource.dataset.productImage);
    } else if (starter === 'cap') {
      var capOption = getHoodieCurrentCapOption(offer);
      title = offer.querySelector('[data-hoodie-gift="cap"] span').textContent;
      image = capOption && capOption.dataset.image;
    } else if (starter === 'love_book') {
      title = offer.querySelector('[data-hoodie-gift="gift_book"] span').textContent;
      var loveBookImage = offer.querySelector('[data-hoodie-gift="gift_book"] img');
      image = loveBookImage && loveBookImage.src;
    } else {
      title = offer.querySelector('[data-hoodie-gift="book"] span').textContent;
      var bookImage = offer.querySelector('[data-hoodie-gift="book"] img');
      image = bookImage && bookImage.src;
    }

    if (titleEl && title) {
      titleEl.textContent = title;
    }

    if (priceEl) {
      priceEl.textContent = formatOfferMoney(price);
    }

    if (imageEl && image) {
      imageEl.src = image;
      if (title) imageEl.alt = title;
    }
  }

  function updateHoodieGiftCards(offer) {
    updateDynamicGiftChoices(offer);

    var starter = getHoodieStarter(offer);
    var giftCards = offer.querySelectorAll('[data-hoodie-gift]:not([data-hoodie-dynamic-gift])');

    giftCards.forEach(function(card) {
      var giftType = card.dataset.hoodieGift;
      card.hidden =
        (starter === 'book' && giftType === 'book') ||
        (starter === 'love_book' && giftType === 'gift_book') ||
        (starter === 'tshirt' && giftType === 'tshirt') ||
        (starter === 'cap' && giftType === 'cap');
    });

    var giftsSection = offer.querySelector('[data-hoodie-gifts-section]');
    if (giftsSection) {
      var visibleGift = false;
      giftsSection.querySelectorAll('[data-hoodie-gift]').forEach(function(card) {
        if (!card.hidden) {
          visibleGift = true;
        }
      });
      giftsSection.hidden = !visibleGift;
    }

    var tshirtSource = getHoodieActiveTshirtSource(offer);
    var tshirtOption = getHoodieCurrentTshirtOption(offer);
    var tshirtProductTitle = tshirtSource && tshirtSource.dataset.productTitle;
    var tshirtImageSrc = (tshirtOption && tshirtOption.dataset.image) || (tshirtSource && tshirtSource.dataset.productImage);

    updateTextGroup(offer, '[data-hoodie-tshirt-title]', tshirtProductTitle);
    updateImageGroup(offer, '[data-hoodie-tshirt-image]', tshirtImageSrc, tshirtProductTitle);

    var capOption = getHoodieCurrentCapOption(offer);
    var capSource = getHoodieActiveCapSource(offer);
    var capTitle = capSource && capSource.dataset.productTitle;
    var capImage = (capOption && capOption.dataset.image) || (capSource && capSource.dataset.productImage);
    updateTextGroup(offer, '[data-hoodie-cap-title]', capTitle);
    updateImageGroup(offer, '[data-hoodie-cap-image]', capImage, capTitle);
  }

  function updateHoodieOfferTotal(offer) {
    var includeOffer = offer.querySelector('[data-hoodie-include-offer]');
    var hoodiePrice = parseInt(offer.dataset.hoodiePrice || '0', 10);
    var starterPrice = includeOffer && includeOffer.checked ? getHoodieStarterPrice(offer) : 0;

    updateTextGroup(offer, '[data-hoodie-total]', formatOfferMoney(hoodiePrice + starterPrice));
    var tshirtOption = getHoodieCurrentTshirtOption(offer);
    var capOption = getHoodieCurrentCapOption(offer);
    var regularValue = hoodiePrice
      + parseInt(offer.dataset.paidBookPrice || '0', 10)
      + parseInt(offer.dataset.giftBookPrice || '0', 10)
      + parseInt((tshirtOption && tshirtOption.dataset.price) || '0', 10)
      + parseInt((capOption && capOption.dataset.price) || '0', 10);
    if (regularValue > 0) {
      updateTextGroup(offer, '[data-hoodie-regular-value]', formatOfferMoney(regularValue));
      updateTextGroup(offer, '[data-hoodie-savings]', formatOfferMoney(Math.max(0, regularValue - hoodiePrice - starterPrice)));
    }

    var controls = offer.querySelector('[data-hoodie-offer-controls]');
    if (controls && includeOffer) {
      controls.hidden = !includeOffer.checked;
    }

    offer.classList.toggle('goforit-hoodie-offer--hoodie-only', includeOffer && !includeOffer.checked);
  }

  function updateStarterHoodieOfferTotal(offer) {
    var includeOffer = offer.querySelector('[data-hoodie-include-offer]');
    var starterPrice = getStarterProductPrice(offer);
    var hoodiePrice = includeOffer && includeOffer.checked ? getStarterHoodiePrice(offer) : 0;

    updateTextGroup(offer, '[data-hoodie-total]', formatOfferMoney(starterPrice + hoodiePrice));
    var regularValue = parseInt(offer.dataset.hoodieRegularValue || '0', 10);
    if (regularValue > 0) {
      updateTextGroup(offer, '[data-hoodie-regular-value]', formatOfferMoney(regularValue));
      updateTextGroup(offer, '[data-hoodie-savings]', formatOfferMoney(Math.max(0, regularValue - starterPrice - hoodiePrice)));
    }

    var controls = offer.querySelector('[data-hoodie-offer-controls]');
    if (controls && includeOffer) {
      controls.hidden = !includeOffer.checked;
    }

    offer.classList.toggle('goforit-hoodie-offer--hoodie-only', includeOffer && !includeOffer.checked);
  }

  function updateStarterHoodieOffer(offer) {
    var activeModel = getHoodieTshirtModel(offer);
    var modelChanged = offer.dataset.activeHoodieTshirtModel !== activeModel;
    offer.dataset.activeHoodieTshirtModel = activeModel;

    updateHoodieTshirtChoices(offer, modelChanged);
    updateHoodieCapChoices(offer);
    updateHoodieBraceletPresentation(offer);
    updateStarterProductCard(offer);
    updateStarterHoodieCard(offer);
    updateStarterValueNote(offer);
    updateHoodieGiftCards(offer);
    updateStarterHoodieOfferTotal(offer);
  }

  function updateHoodieOffer(offer) {
    if (isStarterHoodieOffer(offer)) {
      updateStarterHoodieOffer(offer);
      return;
    }

    updateHoodieProductChoices(offer);
    var activeModel = getHoodieTshirtModel(offer);
    var modelChanged = offer.dataset.activeHoodieTshirtModel !== activeModel;
    offer.dataset.activeHoodieTshirtModel = activeModel;

    updateHoodieTshirtChoices(offer, modelChanged);
    updateHoodieCapChoices(offer);
    updateHoodieBraceletPresentation(offer);
    updateHoodiePaidCard(offer);
    updateHoodieGiftCards(offer);
    updateHoodieOfferTotal(offer);
  }

  function setHoodieOfferButtonText(form, offer) {
    var buttonText = form.querySelector('[data-add-to-cart-text]');
    var includeOffer = offer.querySelector('[data-hoodie-include-offer]');

    if (!buttonText || !includeOffer) return;

    buttonText.textContent = includeOffer.checked
      ? decodeHtmlEntities(offer.dataset.hoodieActiveLabel)
      : decodeHtmlEntities(offer.dataset.hoodieDefaultLabel);

    updateHoodieOffer(offer);
  }

  function setOfferButtonText(form, offer) {
    var buttonText = form.querySelector('[data-add-to-cart-text]');
    var includeTshirt = offer.querySelector('[data-goforit-include-tshirt]');

    if (!buttonText || !includeTshirt) return;

    buttonText.textContent = includeTshirt.checked
      ? decodeHtmlEntities(offer.dataset.goforitActiveLabel)
      : decodeHtmlEntities(offer.dataset.goforitDefaultLabel);

    updateOfferTotal(form, offer);
  }

  function bindProductOfferForms() {
    document.querySelectorAll('[data-goforit-offer]').forEach(function(offer) {
      var form = offer.closest('form');
      if (!form || form.dataset.goforitBound === 'true') return;

      if ((offer.dataset.goforitOfferMode || 'book') === 'book') {
        updateTshirtModel(offer);
      }
      updateBraceletPresentation(offer);
      setOfferButtonText(form, offer);

      var includeTshirt = offer.querySelector('[data-goforit-include-tshirt]');
      if (includeTshirt) {
        includeTshirt.addEventListener('change', function() {
          setOfferButtonText(form, offer);
        });
      }

      offer.querySelectorAll('[data-goforit-tshirt-model]').forEach(function(modelInput) {
        modelInput.addEventListener('change', function() {
          updateTshirtModel(offer);
          setOfferButtonText(form, offer);
        });
      });

      var tshirtProductSelect = offer.querySelector('[data-goforit-tshirt-product]');
      if (tshirtProductSelect) {
        tshirtProductSelect.addEventListener('change', function() {
          updateTshirtModel(offer);
          setOfferButtonText(form, offer);
        });
      }

      offer.querySelectorAll('[data-goforit-tshirt-variant]').forEach(function(tshirtSelect) {
        tshirtSelect.addEventListener('change', function() {
          updateTshirtModel(offer);
          updateOfferTotal(form, offer);
        });
      });

      offer.querySelectorAll('[data-goforit-tshirt-color], [data-goforit-tshirt-size], [data-goforit-tshirt-choice]').forEach(function(choiceSelect) {
        choiceSelect.addEventListener('change', function() {
          updateTshirtModel(offer);
          updateOfferTotal(form, offer);
        });
      });

      var braceletSelect = offer.querySelector('[data-goforit-bracelet-variant]');
      if (braceletSelect) {
        braceletSelect.addEventListener('change', function() {
          updateBraceletPresentation(offer);
        });
      }

      form.dataset.goforitBound = 'true';
    });

    document.addEventListener('submit', async function(event) {
      var form = event.target;
      if (!form || !form.matches('form')) return;

      var offer = form.querySelector('[data-goforit-offer]');
      if (!offer) return;

      var includeTshirt = offer.querySelector('[data-goforit-include-tshirt]');
      if (!includeTshirt || !includeTshirt.checked) return;

      var hoodieOffer = form.querySelector('[data-goforit-hoodie-offer]');
      var includeHoodieOffer = hoodieOffer && hoodieOffer.querySelector('[data-hoodie-include-offer]');
      if (includeHoodieOffer && includeHoodieOffer.checked) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (isProcessing) return;
      isProcessing = true;

      var addButton = form.querySelector('[data-add-to-cart]');
      if (addButton) {
        addButton.disabled = true;
        addButton.classList.add('btn--loading');
      }

      try {
        var formData = new FormData(form);
        var currentVariantId = formData.get('id');
        var quantity = parseInt(formData.get('quantity') || '1', 10);
        var offerMode = offer.dataset.goforitOfferMode || 'book';
        var tshirtOption = offerMode === 'book' ? getCurrentTshirtOption(offer) : null;
        var complementaryVariantId = offerMode === 'tshirt'
          ? offer.dataset.paidBookVariantId
          : (tshirtOption && !tshirtOption.disabled ? tshirtOption.value : '');
        var giftBookVariantId = await getGiftBookVariantId(offer);
        var braceletVariantId = getBraceletVariantId(offer);
        var cart = await fetchCart();
        var items = [];

        if (!currentVariantId || !complementaryVariantId) {
          alert(offerMode === 'book'
            ? 'Veuillez choisir une couleur et une grandeur de T-shirt.'
            : 'Le livre GO FOR IT est temporairement indisponible.');
          return;
        }

        items.push({ id: currentVariantId, quantity: quantity });
        items.push({ id: complementaryVariantId, quantity: quantity });

        if (!cartHasGiftBookGift(cart)) {
          items.push(buildGiftBook(giftBookVariantId));
        }

        if (!cartHasBraceletGift(cart)) {
          items.push(buildBraceletGift(braceletVariantId));
        }

        await addCartItems(items);
        redirectAfterGifts();
      } catch (error) {
        alert('Une erreur est survenue. Veuillez réessayer.');
      } finally {
        isProcessing = false;

        if (addButton) {
          addButton.disabled = false;
          addButton.classList.remove('btn--loading');
        }
      }
    }, true);
  }

  function bindHoodieOfferForms() {
    document.querySelectorAll('[data-goforit-hoodie-offer]').forEach(function(offer) {
      var form = offer.closest('form');
      if (!form || form.dataset.goforitHoodieBound === 'true') return;

      updateHoodieOffer(offer);
      setHoodieOfferButtonText(form, offer);

      var includeOffer = offer.querySelector('[data-hoodie-include-offer]');
      if (includeOffer) {
        includeOffer.addEventListener('change', function() {
          setHoodieOfferButtonText(form, offer);
        });
      }

      offer.querySelectorAll('[data-hoodie-starter]').forEach(function(starterInput) {
        starterInput.addEventListener('change', function() {
          updateHoodieOffer(offer);
        });
      });

      offer.querySelectorAll('[data-hoodie-tshirt-model]').forEach(function(modelInput) {
        modelInput.addEventListener('change', function() {
          updateHoodieOffer(offer);
        });
      });

      offer.querySelectorAll('[data-hoodie-product-color], [data-hoodie-product-size], [data-hoodie-tshirt-product], [data-hoodie-tshirt-color], [data-hoodie-tshirt-size], [data-hoodie-cap-product], [data-hoodie-cap-color]').forEach(function(choiceSelect) {
        choiceSelect.addEventListener('change', function() {
          updateHoodieOffer(offer);
        });
      });

      offer.querySelectorAll('[data-starter-product-option]').forEach(function(choiceSelect) {
        choiceSelect.addEventListener('change', function() {
          updateHoodieOffer(offer);
        });
      });

      var braceletSelect = offer.querySelector('[data-hoodie-bracelet-variant]');
      if (braceletSelect) {
        braceletSelect.addEventListener('change', function() {
          updateHoodieOffer(offer);
        });
      }

      offer.querySelectorAll('[data-hoodie-dynamic-gift-input], [data-hoodie-dynamic-gift-variant]').forEach(function(dynamicGiftControl) {
        dynamicGiftControl.addEventListener('change', function() {
          if (dynamicGiftControl.matches('[data-hoodie-dynamic-gift-input]') && dynamicGiftControl.checked && getDynamicGiftChoiceQuantity(offer) === 1) {
            offer.querySelectorAll('[data-hoodie-dynamic-gift-input]').forEach(function(otherInput) {
              if (otherInput !== dynamicGiftControl) {
                otherInput.checked = false;
              }
            });
          }
          updateHoodieOffer(offer);
        });
      });

      offer.querySelectorAll('[data-hoodie-dynamic-gift]').forEach(function(dynamicGiftCard) {
        dynamicGiftCard.addEventListener('click', function(event) {
          if (event.target.closest('button, a, select, input, label')) return;
          setDynamicGiftSelected(offer, dynamicGiftCard);
        });
      });

      offer.querySelectorAll('[data-hoodie-dynamic-gift-select]').forEach(function(selectButton) {
        selectButton.addEventListener('click', function() {
          var card = selectButton.closest('[data-hoodie-dynamic-gift]');
          setDynamicGiftSelected(offer, card);
        });
      });

      offer.querySelectorAll('[data-hoodie-dynamic-gift-details]').forEach(function(detailsButton) {
        detailsButton.addEventListener('click', function() {
          openDynamicGiftModal(offer, detailsButton.closest('[data-hoodie-dynamic-gift]'));
        });
      });

      var dynamicGiftReset = offer.querySelector('[data-hoodie-dynamic-gift-reset]');
      if (dynamicGiftReset) {
        dynamicGiftReset.addEventListener('click', function() {
          resetDynamicGiftSelection(offer);
        });
      }

      offer.querySelectorAll('[data-hoodie-gift-modal-close]').forEach(function(closeButton) {
        closeButton.addEventListener('click', function() {
          closeDynamicGiftModal(offer);
        });
      });

      var starterHoodieSelect = offer.querySelector('[data-starter-hoodie-variant]');
      if (starterHoodieSelect) {
        starterHoodieSelect.addEventListener('change', function() {
          updateHoodieOffer(offer);
        });
      }

      form.addEventListener('change', function() {
        window.setTimeout(function() {
          updateHoodieOffer(offer);
        }, 0);
      });

      document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape') {
          closeDynamicGiftModal(offer);
        }
      });

      form.dataset.goforitHoodieBound = 'true';
    });

    document.addEventListener('submit', async function(event) {
      var form = event.target;
      if (!form || !form.matches('form')) return;

      var offer = form.querySelector('[data-goforit-hoodie-offer]');
      if (!offer) return;

      var includeOffer = offer.querySelector('[data-hoodie-include-offer]');
      if (!includeOffer || !includeOffer.checked) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (isProcessing) return;
      isProcessing = true;

      var addButton = form.querySelector('[data-add-to-cart]');
      if (addButton) {
        addButton.disabled = true;
        addButton.classList.add('btn--loading');
      }

      try {
        updateHoodieOffer(offer);

        var formData = new FormData(form);
        var starterOffer = isStarterHoodieOffer(offer);
        var starterHoodieOption = starterOffer ? getStarterHoodieOption(offer) : getHoodieProductOption(offer);
        var hoodieVariantId = starterHoodieOption && !starterHoodieOption.disabled ? starterHoodieOption.value : formData.get('id');
        var quantity = parseInt(formData.get('quantity') || '1', 10);
        var starter = getHoodieStarter(offer);
        var tshirtOption = getHoodieCurrentTshirtOption(offer);
        var capOption = getHoodieCurrentCapOption(offer);
        var tshirtSource = getHoodieActiveTshirtSource(offer);
        var capSource = getHoodieActiveCapSource(offer);
        var paidBookVariantId = offer.dataset.paidBookVariantId;
        var giftBookVariantId = await getGiftBookVariantId(offer);
        var braceletVariantId = getHoodieBraceletVariantId(offer);
        var paidStarterVariantId = starterOffer ? getStarterProductVariantId(offer) : paidBookVariantId;
        var paidStarterRole = starterOffer ? 'starter_' + starter : 'starter_book';
        var hasDynamicGiftCards = getDynamicGiftCards(offer).length > 0;
        var dynamicGiftSelection = getDynamicGiftVariantIdsForCart(offer);
        var cart = await fetchCart();
        var items = [];

        if (!starterOffer) {
          var supportedTshirtHandles = ['t-shirt-noir-go-for-it', 't-shirt-col-v-schumann-energy-rose-copie'];
          var selectedTshirtHandle = tshirtSource && tshirtSource.dataset.hoodieProduct;
          var selectedCapHandle = capSource && capSource.dataset.hoodieProduct;
          if (supportedTshirtHandles.indexOf(selectedTshirtHandle) === -1 || selectedCapHandle !== 'casquette-go-for-it') {
            alert('Cette combinaison sera disponible dès la mise à jour finale du moteur de promotion. Pour commander maintenant, choisissez un T-shirt GO FOR IT et la casquette GO FOR IT.');
            return;
          }
        }

        if (!starterOffer && starter === 'tshirt') {
          paidStarterVariantId = tshirtOption && !tshirtOption.disabled ? tshirtOption.value : '';
          paidStarterRole = 'starter_tshirt';
        }

        if (!starterOffer && starter === 'cap') {
          paidStarterVariantId = capOption && !capOption.disabled ? capOption.value : '';
          paidStarterRole = 'starter_cap';
        }

        if (!starterOffer && starter === 'love_book') {
          paidStarterVariantId = giftBookVariantId;
          paidStarterRole = 'starter_love_book';
        }

        if (
          !hoodieVariantId ||
          !paidStarterVariantId ||
          (!starterOffer && (!capOption || capOption.disabled)) ||
          (starter !== 'tshirt' && !hasDynamicGiftCards && (!tshirtOption || tshirtOption.disabled))
        ) {
          alert('Veuillez compléter les choix de votre collection GO FOR IT.');
          return;
        }

        if (dynamicGiftSelection.error) {
          alert(dynamicGiftSelection.error);
          return;
        }

        items.push(buildHoodiePromoPaid(hoodieVariantId, quantity, 'hoodie'));
        items.push(buildHoodiePromoPaid(paidStarterVariantId, quantity, paidStarterRole));

        if (!starterOffer && starter !== 'book') {
          pushHoodiePromoGift(items, cart, paidBookVariantId, 'livre_go_for_it');
        }

        if (!starterOffer && starter !== 'love_book') {
          pushHoodiePromoGift(items, cart, giftBookVariantId, 'livre_amour');
        }

        if (hasDynamicGiftCards) {
          dynamicGiftSelection.ids.forEach(function(variantId) {
            pushHoodiePromoGift(items, cart, variantId, 'cadeau_dynamique');
          });
        }

        if (starter !== 'tshirt') {
          pushHoodiePromoGift(items, cart, tshirtOption.value, 'tshirt');
        }

        if (!starterOffer && starter !== 'cap') {
          pushHoodiePromoGift(items, cart, capOption.value, 'casquette');
        }

        pushHoodiePromoGift(items, cart, braceletVariantId, 'bracelet');

        await addCartItems(items);
        redirectAfterGifts();
      } catch (error) {
        alert('Une erreur est survenue. Veuillez rÃ©essayer.');
      } finally {
        isProcessing = false;

        if (addButton) {
          addButton.disabled = false;
          addButton.classList.remove('btn--loading');
        }
      }
    }, true);
  }

  function bindPromoChoosers() {
    document.querySelectorAll('[data-goforit-promo-chooser]').forEach(function(chooser) {
      var form = chooser.closest('form');
      if (!form || chooser.dataset.goforitPromoChooserBound === 'true') return;

      var simpleOffer = form.querySelector('[data-goforit-offer]');
      var collectionOffer = form.querySelector('[data-goforit-hoodie-offer]');
      if (!collectionOffer) return;

      var simpleToggle = simpleOffer && simpleOffer.querySelector('[data-goforit-include-tshirt]');
      var collectionToggle = collectionOffer.querySelector('[data-hoodie-include-offer]');
      var buttons = chooser.querySelectorAll('[data-goforit-promo-choice]');
      var noPromoButton = chooser.querySelector('[data-goforit-promo-none]');
      var hoodieOnly = !simpleOffer && collectionOffer.classList.contains('goforit-hoodie-offer--hoodie-product');
      var simpleButton = chooser.querySelector('[data-goforit-promo-choice="simple"]');
      var productBlocks = form.closest('[data-product-blocks]');
      var originalVariantWrapper = productBlocks && productBlocks.querySelector('.variant-wrapper');
      var originalVariantBlock = originalVariantWrapper && originalVariantWrapper.closest('.product-block');

      if (simpleOffer) simpleOffer.classList.add('goforit-promo-detail');
      collectionOffer.classList.add('goforit-promo-detail');
      if (simpleOffer) simpleOffer.hidden = true;
      collectionOffer.hidden = true;

      if (hoodieOnly) {
        chooser.classList.add('goforit-promo-chooser--hoodie-only');
        if (simpleButton) simpleButton.hidden = true;
        var heading = chooser.querySelector('[data-goforit-promo-heading]');
        var collectionTitle = chooser.querySelector('[data-goforit-collection-title]');
        var collectionNumber = chooser.querySelector('[data-goforit-promo-choice="collection"] .goforit-promo-choice__number');
        if (heading) heading.textContent = '1 promotion disponible';
        if (collectionTitle) collectionTitle.textContent = 'Promotion collection 5 produits';
        if (collectionNumber) collectionNumber.textContent = 'OFFRE';
      }

      chooser.hidden = false;

      function syncPrices() {
        var simpleSource = simpleOffer && simpleOffer.querySelector('[data-goforit-total]');
        var collectionSource = collectionOffer.querySelector('[data-hoodie-total]');
        var simpleTarget = chooser.querySelector('[data-goforit-promo-choice-total="simple"]');
        var collectionTarget = chooser.querySelector('[data-goforit-promo-choice-total="collection"]');

        if (simpleSource && simpleTarget && ((simpleToggle && simpleToggle.checked) || !simpleTarget.dataset.offerPrice)) {
          simpleTarget.dataset.offerPrice = simpleSource.textContent.trim();
        }
        if (collectionSource && collectionTarget && (collectionToggle.checked || !collectionTarget.dataset.offerPrice)) {
          collectionTarget.dataset.offerPrice = collectionSource.textContent.trim();
        }

        if (simpleTarget && simpleTarget.dataset.offerPrice) simpleTarget.textContent = 'À payer : ' + simpleTarget.dataset.offerPrice;
        if (collectionTarget && collectionTarget.dataset.offerPrice) collectionTarget.textContent = 'À payer : ' + collectionTarget.dataset.offerPrice;
      }

      function setToggle(toggle, checked) {
        if (!toggle || toggle.checked === checked) return;
        toggle.checked = checked;
        toggle.dispatchEvent(new Event('change', { bubbles: true }));
      }

      function setOriginalVariantsHidden(hidden) {
        if (!hoodieOnly || !originalVariantBlock) return;
        originalVariantBlock.classList.toggle('goforit-original-variants--promo-active', hidden);
        originalVariantBlock.setAttribute('aria-hidden', hidden ? 'true' : 'false');
      }

      function selectPromo(choice) {
        var useSimple = choice === 'simple';
        var useCollection = choice === 'collection';

        if (simpleOffer) simpleOffer.hidden = !useSimple;
        collectionOffer.hidden = !useCollection;
        setToggle(simpleToggle, useSimple);
        setToggle(collectionToggle, useCollection);
        setOriginalVariantsHidden(useCollection);

        buttons.forEach(function(button) {
          var selected = button.dataset.goforitPromoChoice === choice;
          button.setAttribute('aria-pressed', selected ? 'true' : 'false');
          var action = button.querySelector('.goforit-promo-choice__action');
          if (action) action.textContent = selected ? 'Promotion sélectionnée' : 'Choisir cette promotion';
        });

        if (noPromoButton) {
          var noPromoSelected = choice === 'none';
          noPromoButton.setAttribute('aria-pressed', noPromoSelected ? 'true' : 'false');
        }

        window.setTimeout(syncPrices, 0);
      }

      syncPrices();
      setToggle(simpleToggle, false);
      setToggle(collectionToggle, false);
      setOriginalVariantsHidden(false);

      buttons.forEach(function(button) {
        button.addEventListener('click', function() {
          selectPromo(button.dataset.goforitPromoChoice);
          var targetOffer = button.dataset.goforitPromoChoice === 'simple' ? simpleOffer : collectionOffer;
          window.setTimeout(function() {
            if (targetOffer) targetOffer.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }, 30);
        });
      });

      if (noPromoButton) {
        noPromoButton.addEventListener('click', function() {
          selectPromo('none');
          chooser.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        });
      }

      form.addEventListener('change', function() {
        window.setTimeout(syncPrices, 0);
      });

      chooser.dataset.goforitPromoChooserBound = 'true';
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    var overlay = getPopupOverlay();
    bindPopupEvents(overlay);
    bindProductOfferForms();
    bindHoodieOfferForms();
    bindPromoChoosers();

    setInterval(checkCart, 1500);
    checkCart();

    if (window.location.pathname === '/cart') {
      setTimeout(monitorCart, 1000);
      setInterval(monitorCart, 3000);
    }
  });
})();
